import { authorizedFetch, AuthorizedFetchWithBaseUrl } from './authorizedFetch';

const get =
  (fetch: AuthorizedFetchWithBaseUrl) =>
  <T>(url: string, headers?: HeadersInit): Promise<T> =>
    fetch(url, { method: 'GET' }, headers);

const put =
  (fetch: AuthorizedFetchWithBaseUrl) =>
  <T, P>(url: string, data: T, headers?: HeadersInit): Promise<P> =>
    fetch(
      url,
      {
        method: 'PUT',
        body: JSON.stringify(data),
      },
      {
        'Content-type': 'application/json',
        ...headers,
      },
    );

const httpDelete =
  (fetch: AuthorizedFetchWithBaseUrl) =>
  <T, P>(url: string, data?: T, headers?: HeadersInit): Promise<P> =>
    fetch(url, { method: 'DELETE', body: JSON.stringify(data) }, { 'Content-type': 'application/json', ...headers });

const post =
  (fetch: AuthorizedFetchWithBaseUrl) =>
  <T, P>(url: string, data: T, headers?: HeadersInit): Promise<P> =>
    fetch(
      url,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      {
        'Content-type': 'application/json',
        ...headers,
      },
    );

const patch =
  (fetch: AuthorizedFetchWithBaseUrl) =>
  <T, P>(url: string, data: T, headers?: HeadersInit): Promise<P> =>
    fetch(
      url,
      {
        method: 'PATCH',
        body: JSON.stringify(data),
      },
      {
        'Content-type': 'application/json',
        ...headers,
      },
    );

export default (
  url: Promise<string> | string,
): {
  get: ReturnType<typeof get>;
  post: ReturnType<typeof post>;
  patch: ReturnType<typeof patch>;
  put: ReturnType<typeof put>;
  httpDelete: ReturnType<typeof httpDelete>;
} => ({
  get: get(authorizedFetch(url)),
  post: post(authorizedFetch(url)),
  patch: patch(authorizedFetch(url)),
  put: put(authorizedFetch(url)),
  httpDelete: httpDelete(authorizedFetch(url)),
});
